import { useEffect, useState } from "react";
import { useSession } from "../store/session/SessionProvider";
import { useSocialApi } from "../lib/api/socialApi";

/**
 * 내 별명(남에게 보이는 이름) — 서버가 정한다(코스+pid 해시 자동 별명 또는 교사 별명표 · SR-SOC-03).
 * 세션 displayName 은 LTI 이름이라 실명일 수 있다: 작품명('…· 별명')·라벨 등 남이 보는 곳에는 쓰지 않는다.
 * GET …/me/nickname 으로 받는다(첫 올리기 전에도). 못 받으면 전시관 목록의 내 작품(mine:true) 별명, 그것도 없으면 null(작품명은 별명 없이).
 */
const cache = new Map<string, string>();

export function rememberMyNickname(courseId: string, nickname: string) {
  if (nickname) cache.set(courseId, nickname);
}

/** refresh 가 바뀌면 다시 묻는다(예: 올리기 완료 뒤 — 이제 내 작품이 목록에 있다) */
export function useMyNickname(refresh?: unknown): string | null {
  const social = useSocialApi();
  const state = useSession();
  const courseId = state.status === "ready" ? state.session.courseId : null;
  const [nick, setNick] = useState<string | null>(() =>
    courseId ? (cache.get(courseId) ?? null) : null,
  );

  useEffect(() => {
    if (!social || !courseId) return;
    let cancelled = false;
    void social
      .myNickname()
      .then(async (n) => n ?? (await social.gallery()).find((i) => i.mine)?.nickname ?? null)
      .then((mine) => {
        if (mine) rememberMyNickname(courseId, mine);
        if (!cancelled) setNick(mine ?? cache.get(courseId) ?? null);
      })
      .catch(() => {
        /* 목록을 못 받으면 별명 없이(실명 대체 없음) */
      });
    return () => {
      cancelled = true;
    };
  }, [social, courseId, refresh]);

  return nick;
}
